/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAwsSsmCommandExecution extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAwsSsmCommandExecution");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAwsSsmCommandExecution.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAwsSsmCommandExecution>): BackgroundJobPayloadForAwsSsmCommandExecution {
        let obj = Object.assign(new BackgroundJobPayloadForAwsSsmCommandExecution(), model);
        BackgroundJobPayloadForAwsSsmCommandExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAwsSsmCommandExecution>): BackgroundJobPayloadForAwsSsmCommandExecution {
        if (!model) return null;
        return BackgroundJobPayloadForAwsSsmCommandExecution.newInstance(<BackgroundJobPayloadForAwsSsmCommandExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAwsSsmCommandExecution) {
        if (!obj) return;

        models.BackgroundJobPayloadForAwsSsmCommandExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAwsSsmCommandExecution): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAwsSsmCommandExecution.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cloud Account id for the background job command execution.
     */
    cloud_account_id: string;

    /**
     * Region of command execution.
     */
    region: string;

    /**
     * ID of command execution in AWS.
     */
    execution_id: string;

    /**
     * Command Execution Status.
     */
    status: string;

}
